// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/css/animate.css'
import '@/assets/css/iconfont/iconfont.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'video.js/dist/video-js.css'

import HeaderMeun from "@/components/header-meun"
import HeaderBanner from "@/components/header-banner"
import FooterBottom from "@/components/footer"
import Side from "@/components/side"
import Banner from "@/components/banner"
import CommonTitle from "@/components/common-title"

Vue.component('HeaderMeun', HeaderMeun);
Vue.component('HeaderBanner', HeaderBanner);
Vue.component('FooterBottom', FooterBottom);
Vue.component('Side', Side);
Vue.component('Banner', Banner);
Vue.component('CommonTitle', CommonTitle);
Vue.use(ElementUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js